import React, { useContext, useState, useEffect } from "react";
import { useFormik, Form, FormikProvider } from "formik";
import * as Yup from "yup";
//Dialog
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import {
  Grid,
  Stack,
  Button,
  TextField,
  Typography,
  IconButton,
  FormHelperText,
} from "@mui/material";
import { useMutation } from "@apollo/client";
//Icons
import { BiMinusCircle } from "react-icons/bi";
//Src
import "../../Style/dialogstyle.scss";
import { AuthContext } from "../../Context/AuthContext";
import {
  SelectGrade,
  SelectAcademicYear,
  SelectGroup,
} from "../Include/DynamicSelect";
import ListItem from "./ListItem";
import { UPDATE_CLASS_ITEM } from "../../Schema/ClassItem";

export default function UpdateClassItem({
  open,
  handleClose,
  setRefetch,
  editData,
}) {
  // Change Language
  const { setAlert } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [requiredField, setRequiredField] = useState(false);

  const [academicYearVal, setAcademicYearVal] = useState({ id: "", title: "" });
  const [classVal, setClassVal] = useState({ id: "", title: "" });
  const [groupVal, setGroupVal] = useState({ id: "", title: "" });

  const item = {
    materialId: { id: "", title: "" },
    listMaterialUnitId: { id: "", title: "", imageSrc: "" },
    qty: 0,
    key: Date.now() + Math.random(),
  };

  const [listItems, setListItems] = useState([item]);

  const handleAddList = () => {
    setListItems([...listItems, item]);
  };

  const handleUpdateList = (key, val, fieldName) => {
    const newList = listItems?.map((d) => {
      if (val === null) {
        if (key === d.key && fieldName === "materialId") {
          d.materialId = { id: "", title: "" };
          d.listMaterialUnitId = { id: "", title: "" };
          d.qty = 0;
        }
        if (key === d.key && fieldName === "listMaterialUnitId") {
          d.listMaterialUnitId = { id: "", title: "" };
          d.qty = 0;
        }
      } else {
        if (key === d.key && fieldName === "materialId") {
          d.listMaterialUnitId.id = "";
          d.listMaterialUnitId.title = "";
          d.materialId = val;
        }
        if (key === d.key && fieldName === "listMaterialUnitId")
          d.listMaterialUnitId = val;
        if (key === d.key && fieldName === "qty") d.qty = parseFloat(val);
      }
      return d;
    });
    setListItems(newList);
  };

  const handleDeleteListItem = (key) => {
    const handleDeleteList = listItems?.filter((d) => d.key !== key);
    setListItems([...handleDeleteList]);
  };

  const [updateClassItem] = useMutation(UPDATE_CLASS_ITEM, {
    onCompleted: ({ updateClassItem }) => {
      // console.log("updateClassItem", updateClassItem);
      setLoading(false);
      if (updateClassItem?.status) {
        setAlert(true, "success", updateClassItem?.message);
        handleClose();
        resetForm();
        setRefetch();
      } else {
        setAlert(true, "error", updateClassItem?.message);
      }
    },
    onError: (error) => {
      setLoading(false);
      setAlert(true, "error", error?.message);
    },
  });

  //fromik
  const CheckValidation = Yup.object().shape({
    academicYearId: Yup.string().required("ទាមទារ!"),
    gradeId: Yup.string().required("ទាមទារ!"),
    groupId: Yup.string(),
    remark: Yup.string(),
  });

  const formik = useFormik({
    initialValues: {
      academicYearId: "",
      gradeId: "",
      groupId: "",
      remark: "",
    },
    validationSchema: CheckValidation,
    onSubmit: async (values) => {
      let createStatus = false;
      const BreakException = {};
      try {
        listItems?.forEach(function (elem) {
          if (
            elem?.materialId?.id !== undefined &&
            elem?.materialId?.id !== "" &&
            elem?.listMaterialUnitId?.id !== undefined &&
            elem?.listMaterialUnitId?.id !== "" &&
            elem?.qty > 0
          ) {
            createStatus = true;
          } else {
            setLoading(false);
            setRequiredField(true);
            createStatus = false;
            throw BreakException;
          }
        });
      } catch (e) {
        if (e !== BreakException) throw e;
      }
      if (createStatus) {
        let listItemToSubmit = listItems?.map((d) => {
          return {
            _id: d?.materialId?.id,
            listMaterialUnitId: d?.listMaterialUnitId?.id,
            qty: d?.qty,
          };
        });
        setLoading(true);
        updateClassItem({
          variables: {
            id: editData?._id,
            input: {
              academicYearId: values?.academicYearId,
              gradeId: values?.gradeId,
              groupId: values?.groupId,
              items: listItemToSubmit,
              remark: values?.remark,
            },
          },
        });
      }
    },
  });

  const {
    errors,
    touched,
    handleSubmit,
    getFieldProps,
    setFieldValue,
    resetForm,
  } = formik;

  useEffect(() => {
    if (academicYearVal?.id) {
      setFieldValue("academicYearId", academicYearVal?.id);
      setFieldValue("gradeId", "");
      setClassVal({ id: "", title: "" });
    } else {
      setFieldValue("academicYearId", "");
    }
  }, [academicYearVal?.id]);

  useEffect(() => {
    if (classVal?.id) {
      setFieldValue("gradeId", classVal?.id);
    } else {
      setFieldValue("gradeId", "");
    }
  }, [classVal?.id]);

  useEffect(() => {
    if (groupVal?.id) {
      setFieldValue("groupId", groupVal?.id);
    } else {
      setFieldValue("groupId", "");
    }
  }, [groupVal?.id]);

  // console.log("editData::", editData);

  useEffect(() => {
    if (editData) {
      setFieldValue("academicYearId", editData?.academicYearId?._id);
      setAcademicYearVal({
        id: editData?.academicYearId?._id,
        title: editData?.academicYearId?.academicYear,
      });

      setFieldValue("gradeId", editData?.gradeId?._id);
      setClassVal({
        id: editData?.gradeId?._id,
        title: editData?.gradeId?.gradeName,
      });

      setFieldValue("groupId", editData?.groupId?._id);
      // setGroupVal({
      //   id: editData?.groupId?._id,
      //   title: editData?.groupId?.groupEnName,
      // });

      setFieldValue("remark", editData?.remark ? editData?.remark : "");

      const newListData = editData?.items?.map((e) => ({
        key: Date.now() + Math.random(),
        materialId: {
          id: e?.listMaterialUnitId?.materialId?._id,
          title: "ISBN: "+e?.listMaterialUnitId?.materialId?.isbm +" - "+e?.listMaterialUnitId?.materialId?.materialEnName,
        },
        listMaterialUnitId: {
          id: e?.listMaterialUnitId?._id,
          title: e?.listMaterialUnitId?.unitId?.unitKhName,
          imageSrc: e?.listMaterialUnitId?.imageSrc,
        },
        qty: e?.qty,
      }));
      setListItems(newListData);
    }
  }, [editData, open]);

  return (
    <Dialog open={open} className="dialog-container" fullWidth maxWidth="lg">
      <DialogTitle sx={{ padding: "10px 15px 10px 20px " }}>
        <Stack direction="row" justifyContent="space-between">
          <Stack direction="column" justifyContent="center">
            <Typography className="dialog-title">
              កែប្រែសម្ភារៈក្នុងថ្នាក់
            </Typography>
          </Stack>
          <Stack direction="column" justifyContent="center">
            <IconButton onClick={handleClose}>
              <BiMinusCircle className="close-icon" />
            </IconButton>
          </Stack>
        </Stack>
      </DialogTitle>

      <DialogContent dividers>
        <FormikProvider value={formik}>
          <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
            <Grid container rowSpacing={2} columnSpacing={3}>
              <Grid item xs={4}>
                <Typography className="field-title">ឆ្នាំសិក្សា</Typography>
                <SelectAcademicYear
                  selectedVal={academicYearVal}
                  setSelectedVal={setAcademicYearVal}
                />
                {!!errors.academicYearId && touched.academicYearId && (
                  <FormHelperText error id="outlined-adornment-password">
                    {errors.academicYearId}
                  </FormHelperText>
                )}
              </Grid>
              <Grid item xs={4}>
                <Typography className="field-title">ថ្នាក់រៀន</Typography>
                <SelectGrade
                  selectedVal={classVal}
                  setSelectedVal={setClassVal}
                  academicYearId={academicYearVal?.id}
                  disabled={academicYearVal?.id ? false : true}
                />
                {!!errors.classId && touched.classId && (
                  <FormHelperText error id="outlined-adornment-password">
                    {errors.classId}
                  </FormHelperText>
                )}
              </Grid>
              {/* <Grid item xs={4}>
                <Typography className="field-title">ក្រុម</Typography>
                <SelectGroup
                  selectedVal={groupVal}
                  setSelectedVal={setGroupVal}
                  isUse={true}
                />
                {!!errors.groupId && touched.groupId && (
                  <FormHelperText error id="outlined-adornment-password">
                    {errors.groupId}
                  </FormHelperText>
                )}
              </Grid> */}

              <Grid item xs={12}>
                <ListItem
                  groupId={groupVal?.id}
                  requiredField={requiredField}
                  listItems={listItems}
                  handleAddList={handleAddList}
                  handleUpdateList={handleUpdateList}
                  handleDeleteList={handleDeleteListItem}
                />
              </Grid>

              <Grid item xs={12}>
                <Typography className="field-title">ចំណាំ</Typography>
                <TextField
                  rows={3}
                  fullWidth
                  multiline
                  size="small"
                  placeholder="ចំណាំ"
                  className="text-field"
                  {...getFieldProps("remark")}
                />
              </Grid>

              <Grid item xs={12}>
                {loading ? (
                  <Button className="btn-create" fullWidth>
                    កំពុងដំណើរការ...
                  </Button>
                ) : (
                  <Button
                    className="btn-create"
                    fullWidth
                    onClick={handleSubmit}
                  >
                    កែប្រែ
                  </Button>
                )}
              </Grid>
            </Grid>
          </Form>
        </FormikProvider>
      </DialogContent>
    </Dialog>
  );
}
